<template>
  <form-wrap
    class="sign-up-form"
    @submit="customCreate"
  >
    <form-field-set :should-show-border="false">
      <text-input
        v-model="workspace"
        :error="fieldError('create', 'workspace')"
        :label="$t('c.signUpForm.form.label.workspace')"
        name="workspace"
        direction="vertical"
      />
      <text-input
        v-model="email"
        :error="fieldError('create', 'email')"
        :label="$t('c.signUpForm.form.label.email')"
        name="email"
        direction="vertical"
      />
      <text-input
        v-model="password"
        :error="fieldError('create', 'password')"
        :label="$t('c.signUpForm.form.label.password')"
        name="password"
        direction="vertical"
        type="password"
      />
      <text-input
        v-model="passwordConfirmation"
        :error="fieldError('create', 'passwordConfirmation')"
        :label="$t('c.signUpForm.form.label.password_confirmation')"
        name="passwordConfirmation"
        direction="vertical"
        type="password"
      />
    </form-field-set>
    <form-actions>
      <button-input
        v-t="'c.signUpForm.form.action.submit'"
        type="submit"
      />
      <router-link
        v-t="'c.signUpForm.form.action.signup'"
        :to="{ name: 'SignInPage' }"
      />
    </form-actions>
  </form-wrap>
</template>

<script>
import FormMixin from '@/mixins/forms/Form'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SignUpForm',
  mixins: [FormMixin],
  computed: {
    ...mapGetters({
      fieldError: 'signUpForm/fieldError'
    }),
    email: {
      get () { return this.$store.state.signUpForm.form.email },
      set (value) { this.$store.dispatch('signUpForm/setEmail', value) }
    },
    password: {
      get () { return this.$store.state.signUpForm.form.password },
      set (value) { this.$store.dispatch('signUpForm/setPassword', value) }
    },
    passwordConfirmation: {
      get () { return this.$store.state.signUpForm.form.passwordConfirmation },
      set (value) { this.$store.dispatch('signUpForm/setPasswordConfirmation', value) }
    },
    workspace: {
      get () { return this.$store.state.signUpForm.form.workspace },
      set (value) { this.$store.dispatch('signUpForm/setWorkspace', value) }
    }
  },
  methods: {
    ...mapActions({
      customCreate: 'signUpForm/customCreate'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/SignUpForm.vue